import initEducatorsSlider from "./init-educators-slider";
import initFaqSlider from "./init-faq-slider";
import initMediaSlider from "./init-media-slider";
import initHowTOGetSlider from "./init-how-to-get-slider";
import initStatusSlider from "./init-status-slider";
import initDissmisalriskSlider from "./init-dissmisalrisk-slider";
import initEducationSlider from "./init-education-slider";
import initCommentsSlider from "./init-comments-slider";
import initPartnersSlider from "./init-partners-slider";
import initOrganizationSliders from "./init-organization-sliders";
import initParticipateSlider from "./init-participate-slider";
import initGrowthSliders from "./init-growth-sliders";
import initCasesSlider from "./init-cases-slider";

const sliders = () => {
    initEducatorsSlider();
    initCasesSlider();
    initMediaSlider();
    initFaqSlider();
    initHowTOGetSlider();
    initStatusSlider();
    initDissmisalriskSlider();
    initEducationSlider();
    initCommentsSlider();
    initPartnersSlider();
    initOrganizationSliders();
    initParticipateSlider();
    initGrowthSliders();
}

export default sliders;
